export const DATES = {
  promptengineertg: [
    {
      name: "Сентябрь",
      date: "02.09.2026",
    }
  ],
  "ai-profession": [
    {
      name: "Сентябрь",
      date: "02.09.2026",
    }
  ],
  "ai-start": [
    {
      name: "Сентябрь",
      date: "02.09.2026",
    }
  ],
  "ai-start-tg": [
    {
      name: "Сентябрь",
      date: "02.09.2026",
    }
  ],
  "ai-start-fb": [
    {
      name: "Сентябрь",
      date: "02.09.2026",
    }
  ],
  promptengineer: [
    {
      name: "Октябрь",
      date: "02.10.2026",
    }
  ],
  promptengineering: [
    {
      name: "Июнь",
      date: "30.06.2026",
    }
  ],
  "promptengineer-marketplace": [
    {
      name: "Сентябрь",
      date: "30.09.2026",
    }
  ],
  "promptengineer-designer": [
    {
      name: "Сентябрь",
      date: "30.09.2026",
    }
  ],
  "promptengineer-hr": [
    {
      name: "Сентябрь",
      date: "30.09.2026",
    }
  ],
  "promptengineer-teaching-and-learning": [
    {
      name: "Сентябрь",
      date: "17.09.2026",
    }
  ],
  "promptengineer-marketing": [
    {
      name: "Сентябрь",
      date: "11.09.2026",
    }
  ],
  operator1c: [
    {
      name: "Октябрь",
      date: "23.10.2026",
    },
  ],
  marketplace: [
    {
      name: "Октябрь",
      date: "02.10.2026",
    }
  ],
  marketplacetg: [
    {
      name: "Сентябрь",
      date: "02.09.2026",
    }
  ],
  "new-marketplace": [
    {
      name: "Сентябрь",
      date: "02.09.2026",
    }
  ],
  nutritionist: [
    {
      name: "Октябрь",
      date: "09.10.2026",
    },
  ],
  psychologist: [
    {
      name: "Сентябрь",
      date: "25.09.2026",
    },
  ],
  "psychologist-advanced": [
    {
      name: "Сентябрь",
      date: "29.09.2026",
    },
  ],
  "self-psychologist": [
    {
      name: "Сентябрь",
      date: "29.09.2026",
    },
  ],
  gestalt: [
    {
      name: "Октябрь",
      date: "09.10.2026",
    },
  ],
  developer1c: [
    {
      name: "Сентябрь",
      date: "08.09.2026",
    }
  ],
  "new-developer1c": [
    {
      name: "Июль",
      date: "17.07.2026",
    }
  ],
  graphicdesign: [
    {
      name: "Сентябрь",
      date: "15.09.2026",
    },
  ],
  "new-graphicdesign": [
    {
      name: "Сентябрь",
      date: "15.09.2026",
    },
  ],
  accountant: [
    {
      name: "Сентябрь",
      date: "29.09.2026",
    }
  ],
  "project-manager": [
    {
      name: "Сентябрь",
      date: "15.09.2026",
    },
  ],
  "excel-data": [
    {
      name: "Сентябрь",
      date: "15.09.2026",
    }
  ],
  "advertising-agent": [
    {
      name: "Май",
      date: "29.05.2026",
    },
  ],
  "internet-marketer": [
    {
      name: "Октябрь",
      date: "09.10.2026",
    },
  ],
  "ai-course": [
    {
      name: "Май",
      date: "05.05.2026",
    },
  ],
  "foreign-trade-china": [
    {
      name: "Сентябрь",
      date: "23.09.2026",
    },
  ],
  "software-testing": [
    {
      name: "Сентябрь",
      date: "29.09.2026",
    },
  ],
  "data-analytics": [
    {
      name: "Сентябрь",
      date: "29.09.2026",
    },
  ],
  "promptengineer-pro": [
    {
      name: "Октябрь",
      date: "06.10.2026",
    },
  ],
  "social-media": [
    {
      name: "Октябрь",
      date: "15.10.2026",
    },
  ],
  "methodist": [
    {
      name: "Сентябрь",
      date: "17.09.2026",
    },
  ],
  "information-security": [
    {
      name: "Сентябрь",
      date: "17.09.2026",
    },
  ],
  "procurement": [
    {
      name: "Сентябрь",
      date: "17.09.2026",
    },
  ],
  "pedagogy": [
    {
      name: "Сентябрь",
      date: "29.09.2026",
    },
  ],
  "hr": [
    {
      name: "Сентябрь",
      date: "29.09.2026",
    },
  ],
  "logistics": [
    {
      name: "Сентябрь",
      date: "29.09.2026",
    },
  ],
  "foreign-trade-china-marketplace": [
    {
      name: "Октябрь",
      date: "02.10.2026",
    },
  ],
  "promptengineer-accountant": [
    {
      name: "Сентябрь",
      date: "17.09.2026",
    },
  ],
  "internet-marketer-promptengineer": [
    {
      name: "Октябрь",
      date: "09.10.2026",
    },
  ],
  "ai-specialist-business": [
    {
      name: "Октябрь",
      date: "02.10.2026",
    },
  ],
  "marketplace-ai": [
    {
      name: "Октябрь",
      date: "02.10.2026",
    },
  ],
  "graphicdesign-ai": [
    {
      name: "Октябрь",
      date: "30.10.2026",
    },
  ],
  "pro-analyst": [
    {
      name: "Октябрь",
      date: "28.10.2026",
    },
  ],
};
